import { render, staticRenderFns } from "./NewInventarPopup.vue?vue&type=template&id=025dac72&scoped=true"
import script from "./NewInventarPopup.vue?vue&type=script&lang=js"
export * from "./NewInventarPopup.vue?vue&type=script&lang=js"
import style0 from "./NewInventarPopup.vue?vue&type=style&index=0&id=025dac72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025dac72",
  null
  
)

export default component.exports